function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';

import { Editor } from 'slate-react';
import { Value } from 'slate';

import Html from 'slate-html-serializer';
import { isKeyHotkey } from 'is-hotkey';

import Showdown from "showdown";
import Turndown from "turndown";

import { Buttongroup } from "../";

import FieldLanguage from "./FieldLanguage";

import Toolbar from "./FieldEditorToolbar";
import Button from "./FieldEditorButton";
import "./FieldEditor.scss";

import htmlRules from "./FieldEditor.htmlRules";

/**
 * Define the default node type.
 *
 * @type {String}
 */

var DEFAULT_NODE = 'paragraph';

/**
 * Define hotkey matchers.
 *
 * @type {Function}
 */

var isBoldHotkey = isKeyHotkey('mod+b');
var isItalicHotkey = isKeyHotkey('mod+i');
var isUnderlinedHotkey = isKeyHotkey('mod+u');
var isCodeHotkey = isKeyHotkey('mod+`');
var isParagraphHotkey = isKeyHotkey('mod+return');

// html + intitial value

var html = new Html({ rules: htmlRules });

var converter = new Showdown.Converter({
    noHeaderId: true
});

var turndown = new Turndown({
    headingStyle: "atx",
    bulletListMarker: "-"
});

var initialValue = '<p><strong>Strong</strong> <em>emphasiz</em></p>';

var FieldEditor = function (_Component) {
    _inherits(FieldEditor, _Component);

    function FieldEditor() {
        var _temp, _this, _ret;

        _classCallCheck(this, FieldEditor);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            value: html.deserialize('<p></p>')
        }, _this.componentDidUpdate = function (prevProps, prevState) {

            if (prevProps.value !== _this.props.value) {
                _this.getInitialValue();
            }
        }, _this.getInitialValue = function () {
            var value = _this.props.value;


            var htmlValue = converter.makeHtml(value);

            _this.setState({
                value: html.deserialize(htmlValue)
            });
        }, _this.hasMark = function (type) {
            var value = _this.state.value;

            return value.activeMarks.some(function (mark) {
                return mark.type === type;
            });
        }, _this.hasBlock = function (type) {
            var value = _this.state.value;

            return value.blocks.some(function (node) {
                return node.type === type;
            });
        }, _this.ref = function (editor) {
            _this.editor = editor;
        }, _this.renderMarkButton = function (type, icon) {
            var isActive = _this.hasMark(type);

            return React.createElement(Button, { selected: isActive, onMouseDown: function onMouseDown(event) {
                    return _this.onClickMark(event, type);
                }, value: type });
        }, _this.renderBlockButton = function (type, icon) {
            var isActive = _this.hasBlock(type);

            if (['numbered-list', 'bulleted-list'].includes(type)) {
                var _this$state$value = _this.state.value,
                    document = _this$state$value.document,
                    blocks = _this$state$value.blocks;


                if (blocks.size > 0) {
                    var parent = document.getParent(blocks.first().key);
                    isActive = _this.hasBlock('list-item') && parent && parent.type === type;
                }
            }

            return React.createElement(Button, { selected: isActive, onMouseDown: function onMouseDown(event) {
                    return _this.onClickBlock(event, type);
                }, value: type });
        }, _this.renderBlock = function (props, editor, next) {
            var attributes = props.attributes,
                children = props.children,
                node = props.node;


            switch (node.type) {
                case 'block-quote':
                    return React.createElement(
                        'blockquote',
                        attributes,
                        children
                    );
                case 'bulleted-list':
                    return React.createElement(
                        'ul',
                        attributes,
                        children
                    );
                case 'heading-1':
                    return React.createElement(
                        'h1',
                        attributes,
                        children
                    );
                case 'heading-2':
                    return React.createElement(
                        'h2',
                        attributes,
                        children
                    );
                case 'heading-3':
                    return React.createElement(
                        'h3',
                        attributes,
                        children
                    );
                case 'heading-4':
                    return React.createElement(
                        'h4',
                        attributes,
                        children
                    );
                case 'heading-5':
                    return React.createElement(
                        'h5',
                        attributes,
                        children
                    );
                case 'heading-6':
                    return React.createElement(
                        'h6',
                        attributes,
                        children
                    );
                case 'list-item':
                    return React.createElement(
                        'li',
                        attributes,
                        children
                    );
                case 'numbered-list':
                    return React.createElement(
                        'ol',
                        attributes,
                        children
                    );
                case 'paragraph':
                    return React.createElement(
                        'p',
                        attributes,
                        children
                    );
                default:
                    return next();
            }
        }, _this.renderMark = function (props, editor, next) {
            var children = props.children,
                mark = props.mark,
                attributes = props.attributes;


            switch (mark.type) {
                case 'bold':
                    return React.createElement(
                        'strong',
                        attributes,
                        children
                    );
                case 'code':
                    return React.createElement(
                        'code',
                        attributes,
                        children
                    );
                case 'italic':
                    return React.createElement(
                        'em',
                        attributes,
                        children
                    );
                case 'delete':
                    return React.createElement(
                        'del',
                        attributes,
                        children
                    );
                case 'underlined':
                    return React.createElement(
                        'u',
                        attributes,
                        children
                    );
                default:
                    return next();
            }
        }, _this.onChange = function (_ref) {
            var value = _ref.value;


            if (value.document != _this.state.value.document) {
                var htmlValue = html.serialize(value);
                var markdownValue = turndown.turndown(htmlValue);

                _this.setState({
                    htmlValue: htmlValue,
                    markdownValue: markdownValue
                });

                if (_this.props.onChange) {
                    _this.props.onChange(markdownValue);
                }
            }

            _this.setState({
                value: value
            });
        }, _this.onKeyDown = function (event, editor, next) {
            var mark = void 0;

            if (isBoldHotkey(event)) {
                mark = 'bold';
            } else if (isItalicHotkey(event)) {
                mark = 'italic';
            } else if (isUnderlinedHotkey(event)) {
                mark = 'underlined';
            } else if (isCodeHotkey(event)) {
                mark = 'code';
            } else {
                return next();
            }

            event.preventDefault();
            editor.toggleMark(mark);
        }, _this.onClickMark = function (event, type) {
            event.preventDefault();
            _this.editor.toggleMark(type);
        }, _this.onClickBlock = function (event, type) {
            event.preventDefault();

            var _this2 = _this,
                editor = _this2.editor;
            var value = editor.value;
            var document = value.document;

            // Handle everything but list buttons.

            if (type !== 'bulleted-list' && type !== 'numbered-list') {
                var isActive = _this.hasBlock(type);
                var isList = _this.hasBlock('list-item');

                if (isList) {
                    editor.setBlocks(isActive ? DEFAULT_NODE : type).unwrapBlock('bulleted-list').unwrapBlock('numbered-list');
                } else {
                    editor.setBlocks(isActive ? DEFAULT_NODE : type);
                }
            } else {
                // Handle the extra wrapping required for list buttons.
                var _isList = _this.hasBlock('list-item');

                var isType = value.blocks.some(function (block) {
                    return !!document.getClosest(block.key, function (parent) {
                        return parent.type === type;
                    });
                });

                if (_isList && isType) {
                    editor.setBlocks(DEFAULT_NODE).unwrapBlock('bulleted-list').unwrapBlock('numbered-list');
                } else if (_isList) {
                    editor.unwrapBlock(type === 'bulleted-list' ? 'numbered-list' : 'bulleted-list').wrapBlock(type);
                } else {
                    editor.setBlocks('list-item').wrapBlock(type);
                }
            }
        }, _this.getClassName = function () {
            var _this$props = _this.props,
                className = _this$props.className,
                type = _this$props.type;


            var classNames = [];

            classNames.push('admin-field');
            classNames.push('field--input');
            classNames.push('field--editor');

            return classNames.join(' ');
        }, _this.renderToolbar = function () {
            var language = _this.props.language;


            return React.createElement(
                Toolbar,
                null,
                React.createElement(FieldLanguage, { language: language }),
                React.createElement(
                    Buttongroup,
                    null,
                    _this.renderBlockButton('paragraph'),
                    _this.renderBlockButton('heading-1'),
                    _this.renderBlockButton('heading-2'),
                    _this.renderBlockButton('heading-3'),
                    _this.renderBlockButton('heading-4'),
                    _this.renderBlockButton('block-quote')
                ),
                React.createElement(
                    Buttongroup,
                    null,
                    _this.renderBlockButton('bulleted-list'),
                    _this.renderBlockButton('numbered-list')
                ),
                React.createElement(
                    Buttongroup,
                    null,
                    _this.renderMarkButton('bold'),
                    _this.renderMarkButton('italic'),
                    _this.renderMarkButton('delete')
                )
            );

            return React.createElement(
                Toolbar,
                null,
                _this.renderMarkButton('bold', 'format_bold'),
                _this.renderMarkButton('italic', 'format_italic'),
                _this.renderMarkButton('underlined', 'format_underlined'),
                _this.renderMarkButton('code', 'code'),
                _this.renderBlockButton('heading-1', 'looks_one'),
                _this.renderBlockButton('heading-2', 'looks_two'),
                _this.renderBlockButton('block-quote', 'format_quote'),
                _this.renderBlockButton('numbered-list', 'format_list_numbered'),
                _this.renderBlockButton('bulleted-list', 'format_list_bulleted')
            );
        }, _this.renderEditor = function () {
            var _this$props2 = _this.props,
                language = _this$props2.language,
                placeholder = _this$props2.placeholder;
            var _this$state = _this.state,
                value = _this$state.value,
                markdownValue = _this$state.markdownValue,
                htmlValue = _this$state.htmlValue;


            return React.createElement(
                'div',
                { className: 'admin-field__editor' },
                React.createElement(Editor, {
                    autoFocus: false,
                    autoCorrect: false,
                    placeholder: placeholder,
                    ref: _this.ref,
                    value: value,
                    onChange: _this.onChange,
                    onKeyDown: _this.onKeyDown,
                    renderBlock: _this.renderBlock,
                    renderMark: _this.renderMark
                })
            );

            return React.createElement(
                'div',
                null,
                'HTML preview:',
                React.createElement(ReactMarkdown, { className: 'field__string', source: htmlValue }),
                'Markdown preview:',
                React.createElement(ReactMarkdown, { className: 'field__string', source: markdownValue }),
                _this.state.markdownValue
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    FieldEditor.prototype.componentDidMount = function componentDidMount() {
        this.getInitialValue();
    };

    FieldEditor.prototype.render = function render() {
        var className = this.getClassName();

        return React.createElement(
            'div',
            { className: className },
            this.renderToolbar(),
            this.renderEditor()
        );
    };

    return FieldEditor;
}(Component);

export default FieldEditor;